import { render, staticRenderFns } from "./VmChangeBootIndex.vue?vue&type=template&id=5e5a2473&scoped=true&"
import script from "./VmChangeBootIndex.vue?vue&type=script&lang=js&"
export * from "./VmChangeBootIndex.vue?vue&type=script&lang=js&"
import style0 from "./VmChangeBootIndex.vue?vue&type=style&index=0&id=5e5a2473&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a2473",
  null
  
)

export default component.exports